export default __webpack_public_path__ + "static/media/video-1.a1061371.mp4";